import { FC } from 'react';

import { Card, CardTitle, ColorField, Field, FormGrid, Select } from '../../../ui';
import QrImageField from './QrImageField';
import { LogoDisplay, PaynowForm, SetPaynowField, parseQrStyle } from './types';

type QrAppearanceCardProps = {
  form: PaynowForm;
  setField: SetPaynowField;
  logo: LogoDisplay;
  uploading: boolean;
  onChoose: (file: File) => void;
  onRemove: () => void;
};

/** How the code is drawn: the style, the module colour and the optional image. */
const QrAppearanceCard: FC<QrAppearanceCardProps> = ({ form, setField, logo, uploading, onChoose, onRemove }) => (
  <Card className="paymentCard">
    <CardTitle>QR appearance</CardTitle>
    <FormGrid columns={2}>
      <Field id="paynow-style" label="Style">
        <Select value={form.style} onChange={(changed) => setField('style', parseQrStyle(changed.target.value))}>
          <option value="plain">Plain code</option>
          <option value="logo" disabled={!logo.url}>
            Logo in the middle
          </option>
          <option value="halftone" disabled={!logo.url}>
            Halftone picture
          </option>
          <option value="photo" disabled={!logo.url}>
            Picture background
          </option>
        </Select>
      </Field>

      <ColorField id="paynow-colour" label="Colour" value={form.color} onChange={(value) => setField('color', value)} />

      <QrImageField logo={logo} style={form.style} uploading={uploading} onChoose={onChoose} onRemove={onRemove} />
    </FormGrid>
  </Card>
);

export default QrAppearanceCard;
